let ignoreFocus = false
/**
 * Reads the nested property by stepping into the object using
 * using the given path as keys.
 */
function getNestedProperty (object, path) {
  if (typeof object === 'undefined') {
    console.error('Trying to access nested properties of undefined variable, should be an object')
    return undefined
  }

  const pList = path.split('.')
  const len = pList.length
  for (let i = 0; i < len - 1; i++) {
    const elem = pList[i]
    if (!object[elem]) return undefined
    object = object[elem]
  }

  return object[pList[len - 1]]
}

/**
 * Sets the nested property by stepping into the object using
 * using the given path as keys to specified value
 */
function setNestedProperty (object, path, value) {
  if (typeof object === 'undefined') {
    console.error('Trying to access nested properties of undefined variable, should be an object')
    return null
  }

  const pList = path.split('.')
  const len = pList.length
  for (let i = 0; i < len - 1; i++) {
    const elem = pList[i]
    if (!object[elem]) object[elem] = {}
    object = object[elem]
  }

  object[pList[len - 1]] = value
}

function registerInput (register, path) {
  const found = register.find((p) => { return p === path })
  if (!found) {
    register.push(path)
  }
}

/**
 * Returns the properties of the check result object that don't represents
 * internals (that are starting with a $)
 */
function vflowGetNonInternalCheckProps (check) {
  const result = []

  try {
    if (check !== null) {
      Object.entries(check).forEach((k, v) => {
        if (k[0].substr(0, 1) !== '$') {
          result.push(k[0])
        }
      })
    }
  } catch (e) {
    console.error('vflowGetNonInternalCheckProps', 'check is undefined or invalid', check)
    throw e
  }

  return result
}

/**
 * Checks if the given property has a required validation
 * that has failed
 */
const vflowHasFailedRequired = function (path, treatAsRequired) {
  registerInput(this.vflowRegisteredInputs, path)
  const check = getNestedProperty(this.$v, path)

  // no check, no require
  if (!check) {
    return false
  }

  // no require
  const vName = (typeof treatAsRequired !== 'undefined' && treatAsRequired !== null && treatAsRequired !== '') ? treatAsRequired : 'required'
  if (typeof check[vName] === 'undefined') {
    return false
  }

  const result = !check[vName]

  return result
}

/**
 * Checks if the given property has a required validation
 * that has failed
 */
const vflowGetRequiredFailedClass = function (path, treatAsRequired) {
  registerInput(this.vflowRegisteredInputs, path)
  if (this.vflowHasFailedRequired(path, treatAsRequired)) {
    return { 'required-failed': true }
  }

  return {}
}

/**
 * Checks if the given property has a required validation
 * that has failed
 */
const vflowGetFeedbackClasses = function (path, treatAsRequired) {
  registerInput(this.vflowRegisteredInputs, path)
  const classes = {}

  // check value
  const v = getNestedProperty(this, path)
  if (typeof v !== 'undefined' && v !== null && v !== '' && v !== false) {
    classes['is-not-empty'] = true
  } else {
    classes['is-empty'] = true
  }

  // valid?
  if (!this.vflowHasFailedRequired(path, treatAsRequired) && !this.vflowAnyExceptRequiredFailed(path, treatAsRequired)) {
    classes['is-valid'] = true
  } else {
    if (this.vflowHasFailedRequired(path, treatAsRequired)) {
      classes['required-failed'] = true
    } else {
      if (this.vflowAnyExceptRequiredFailed(path, treatAsRequired)) {
        classes['other-validation-failed'] = true
      }
    }

    if (getNestedProperty(this.vflowFeedbackState, path)) {
      classes['show-feedback'] = true
    }
  }

  return classes
}

/**
 * Checks if there is a validation except required that has failed
 */
const vflowAnyExceptRequiredFailed = function (path, treatAsRequired) {
  let found = false

  try {
    registerInput(this.vflowRegisteredInputs, path)
    const check = getNestedProperty(this.$v, path)
    const validations = vflowGetNonInternalCheckProps(check)
    const vName = (typeof treatAsRequired !== 'undefined' && treatAsRequired !== null && treatAsRequired !== '') ? treatAsRequired : 'required'

    if (typeof check !== 'undefined') {
      validations.forEach((v) => {
        if (v !== vName) {
          if (!check[v]) {
            found = true
          }
        }
      })
    }
  } catch (e) {
    console.error('vflowAnyExceptRequiredFailed', 'failed for ' + path)
  }

  return found
}

/**
 * Sets the state blurred for a field
 */
const vflowInputBlurred = function (path) {
  registerInput(this.vflowRegisteredInputs, path)
  setNestedProperty(this.vflowStatesBlurred, path, true)
  setNestedProperty(this.vflowStatesFocused, path, false)

  const v = getNestedProperty(this, path)

  // check if blurred with input then give feedback
  if (typeof v !== 'undefined' && v !== '') {
    setNestedProperty(this.vflowFeedbackState, path, true)
  }

  // drop and reset value of data property to force-rerendering of component
  // only if it's not a prop
  const p = getNestedProperty(this.$props, path)
  if (typeof p === 'undefined') {
    this.$nextTick(() => {
      setNestedProperty(this, path, '')
      setNestedProperty(this, path, null)
      setNestedProperty(this, path, v)
    })
  }
}

/**
 * Checks if an element is blurred
 */
const vflowIsBlurred = function (path) {
  const v = getNestedProperty(this.vflowStatesBlurred, path)
  return (v === true)
}

/**
 * Set the focused state for a field
 */
const vflowInputFocused = function (path) {
  if (ignoreFocus) {
    ignoreFocus = false
    return
  }

  registerInput(this.vflowRegisteredInputs, path)
  setNestedProperty(this.vflowStatesFocused, path, true)
  setNestedProperty(this.vflowStatesBlurred, path, false)
  setNestedProperty(this.vflowFeedbackState, path, false)

  // drop and reset value of data property to force-rerendering of component
  const v = getNestedProperty(this, path)
  const p = getNestedProperty(this.$props, path)
  if (typeof p === 'undefined') {
    this.$nextTick(() => {
      setNestedProperty(this, path, '')
      setNestedProperty(this, path, null)
      setNestedProperty(this, path, v)
      this.$forceUpdate()
    })
  } else {
    this.$nextTick(() => {
      this.$forceUpdate()
    })
  }
}

/**
 * Checks if there is any focused element
 */
const vflowIsAnyInputFocused = function () {
  this.vflowRegisteredInputs.forEach((path) => {
    if (getNestedProperty(this.vflowStatesFocused, path) === true) {
      return true
    }
  })

  return false
}

/**
 * Checks if there is any blurred element
 */
const vflowIsAnyInputBlurred = function () {
  this.vflowRegisteredInputs.forEach((path) => {
    if (getNestedProperty(this.vflowStatesBlurred, path) === true) {
      return true
    }
  })

  return false
}

/**
 * Gets the validation result object of the given property
 * The fields must be named in reverse order than the keys in the
 * object are arranged, i. e. ['first', 'name', 'person'] to access
 * object.person.name.first
 */
const vflowGetCheckResultObject = function (path) {
  registerInput(this.vflowRegisteredInputs, path)
  return getNestedProperty(this.$v, path)
}

/**
 * Sets the feedback state for all registered inputs
 */
const vflowForceFeedback = function () {
  this.vflowRegisteredInputs.forEach((path) => {
    setNestedProperty(this.vflowFeedbackState, path, true)

    // drop and reset value of data property to force-rerendering of component
    const v = getNestedProperty(this, path)
    const p = getNestedProperty(this.$props, path)
    if (typeof p === 'undefined') {
      this.$nextTick(() => {
        setNestedProperty(this, path, '')
        setNestedProperty(this, path, null)
        setNestedProperty(this, path, v)
        this.$forceUpdate()
      })
    } else {
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    }
  })
}

/**
 * Sets the feedback state for all registered inputs
 */
const vflowResetFeedbackStates = function () {
  this.vflowRegisteredInputs.forEach((path) => {
    setNestedProperty(this.vflowFeedbackState, path, false)
  })
}

/**
 * Registers an input
 */
const vflowRegisterInput = function (path) {
  registerInput(this.vflowRegisteredInputs, path)
}

/**
 * Scrolls to the first element with active feedback
 */
const vFlowScrollToFirstElemment = function () {
  setTimeout(() => {
    const feedbackEl = document.getElementsByClassName('show-feedback')
    if (feedbackEl && feedbackEl.length > 0 && feedbackEl[0] && feedbackEl[0].scrollIntoView) {
      feedbackEl[0].scrollIntoView({ behavior: 'smooth', block: 'center' })
      requestAnimationFrame(() => {
        ignoreFocus = true
        feedbackEl[0].querySelector('input, textarea')?.focus()
      })
    }
  }, 250)
}

const vFlowGetFirstErrorElementName = function () {
  var promise = new Promise(function (resolve, reject) {
    window.setTimeout(function () {
      let returnField = ''
      const feedbackEl = document.getElementsByClassName('show-feedback')
      if (feedbackEl && feedbackEl.length > 0 && feedbackEl[0] && feedbackEl[0].getElementsByTagName('input')[0] !== 'undefined') {
        if (feedbackEl[0].getElementsByTagName('input')[0].name !== 'undefined' && feedbackEl[0].getElementsByTagName('input')[0].name !== '') {
          returnField = feedbackEl[0].getElementsByTagName('input')[0].name
        } else {
          returnField = feedbackEl[0].getElementsByTagName('input')[0].id
        }
      }
      resolve(returnField)
    })
  })
  return promise
}

export default {
  data () {
    return {
      vflowRegisteredInputs: [],
      vflowStatesBlurred: {},
      vflowStatesFocused: {},
      vflowFeedbackState: {},
      vflowReRender: {}
    }
  },
  mounted () {
    this.vflowResetFeedbackStates()
  },
  methods: {
    vflowHasFailedRequired,
    vflowAnyExceptRequiredFailed,
    vflowInputBlurred,
    vflowInputFocused,
    vflowGetCheckResultObject,
    vflowGetRequiredFailedClass,
    vflowForceFeedback,
    vflowGetFeedbackClasses,
    vflowRegisterInput,
    vFlowScrollToFirstElemment,
    vflowIsAnyInputFocused,
    vflowIsAnyInputBlurred,
    vflowIsBlurred,
    vflowResetFeedbackStates,
    vFlowGetFirstErrorElementName
  }
}
